import { createContext, PropsWithChildren, useContext } from 'react';
import { useToggle } from 'shared/hooks';

interface QuoteDetailContext {
  dialogOpen: boolean;
  toggleDialog: () => void;
}

const newQuoteContext = createContext({} as QuoteDetailContext);

export function ProvideNewQuoteState({ children }: PropsWithChildren<{}>) {
  const [dialogOpen, toggleDialog] = useToggle();
  return (
    <newQuoteContext.Provider
      value={{
        dialogOpen,
        toggleDialog,
      }}
    >
      {children}
    </newQuoteContext.Provider>
  );
}

export function useNewQuoteState() {
  return useContext(newQuoteContext);
}
